import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ImagePreviewDialogComponent } from '@app/shared/image-preview-dialog/image-preview-dialog.component';

@NgModule({
  declarations: [ImagePreviewDialogComponent],
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule, MatTooltipModule, TranslateModule],
  exports: [ImagePreviewDialogComponent],
})
export class ImagePreviewDialogModule {}
